var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _animateTransform;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#000000",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#cccccc",
    fillOpacity: 0.2,
    transform: "rotate(30 64 64)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#cccccc",
    fillOpacity: 0.2,
    transform: "rotate(60 64 64)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#cccccc",
    fillOpacity: 0.2,
    transform: "rotate(90 64 64)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#cccccc",
    fillOpacity: 0.2,
    transform: "rotate(120 64 64)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#b2b2b2",
    fillOpacity: 0.3,
    transform: "rotate(150 64 64)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#999999",
    fillOpacity: 0.4,
    transform: "rotate(180 64 64)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#7f7f7f",
    fillOpacity: 0.5,
    transform: "rotate(210 64 64)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#666666",
    fillOpacity: 0.6,
    transform: "rotate(240 64 64)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#4c4c4c",
    fillOpacity: 0.7,
    transform: "rotate(270 64 64)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#333333",
    fillOpacity: 0.8,
    transform: "rotate(300 64 64)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 0h8v40h-8V0z",
    fill: "#191919",
    fillOpacity: 0.9,
    transform: "rotate(330 64 64)"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 0 0;30 0 0;60 0 0;90 0 0;120 0 0;150 0 0;180 0 0;210 0 0;240 0 0;270 0 0;300 0 0;330 0 0",
    calcMode: "discrete",
    dur: "1080ms",
    repeatCount: "indefinite"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.93cbfaecf727c5c9dad27e86b6479b39.svg";
export { ForwardRef as ReactComponent };